document.addEventListener('DOMContentLoaded', function () {
  if (window.screen.width < 800) {
    // ----- MENU -----
    var menu = document.querySelector('.main_nav .show_menu');
    var closeMenu = document.querySelector('.main_nav .close_menu');
    var menuForm = document.querySelector('.modal_parent');
    menu.addEventListener('click', openMenu);
    closeMenu.addEventListener('click', closemenu);
    function openMenu() {
      menuForm.classList.add('is_active');
      menu.classList.add('hidden_button');
      closeMenu.classList.add('visible_button');
    }
    function closemenu() {
      menuForm.classList.remove('is_active');
      menu.classList.remove('hidden_button');
      closeMenu.classList.remove('visible_button');
    }
    menuForm.addEventListener('click', function (event) {
      if (!event.target.closest('.inner')) {
        closemenu();
      }
    });
    // ----- END OF MENU -----
    var arrowIcon = document.querySelectorAll('.submenu_mobile_icn');
    arrowIcon.forEach(function (i) {
      i.addEventListener('click', toggleSubmenu);
      function toggleSubmenu(e) {
        e.stopPropagation();
        e.preventDefault();
        var submenu = this.parentNode.children[2];
        if (submenu.classList.contains("submenu_show")) {
          submenu.classList.remove("submenu_show");
          this.classList.remove("active_svg");
        } else {
          submenu.classList.add("submenu_show");
          this.classList.add("active_svg");
        }
      }
    });
  }
  //----- SEARCH -----
  var searchIcon = document.querySelector(".main_header .search .search_icon");
  var closeSearch = document.querySelector(".main_header .search .close_search");
  var searchForm = document.querySelector(".main_header .search .search_parent");
  var searchInput = document.querySelector(".main_header .search .search_input");
  if (searchIcon && searchForm) {
    searchIcon.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      searchForm.classList.add("visible");
      searchIcon.classList.add("hidden_button");
      closeSearch.classList.add("visible_button");
      searchInput.focus();
    });
    closeSearch.addEventListener("click", function (e) {
      e.preventDefault();
      closeSearchFunc();
    });
    searchForm.addEventListener("click", function (e) {
      if (!searchIcon.contains(e.target) && !searchInput.contains(e.target)) {
        closeSearchFunc();
      }
    });
  }
  function closeSearchFunc() {
    searchForm.classList.remove("visible");
    searchIcon.classList.remove("hidden_button");
    closeSearch.classList.remove("visible_button");
  }
  // ----- ADDED POSITION FIXED TO MODAL_PARENT & SEARCH_PARENT ----- //
  function handleScrollModalTop() {
    const header = document.querySelector('.main_header');
    const modal = document.querySelector('.modal_parent');
    const modalSearchList = document.querySelectorAll('.search_parent');
  
    if (!header || !modal) return;
  
    const headerHeight = header.offsetHeight;
  
    if (window.scrollY >= headerHeight) {
      modal.classList.add('scrolled');
  
      modalSearchList.forEach(function (search) {
        if (search.classList.contains('visible')) {
          search.classList.add('scrolled');
        }
      });
  
    } else {
      modal.classList.remove('scrolled');
  
      modalSearchList.forEach(function (search) {
        search.classList.remove('scrolled');
      });
    }
  }
  
  handleScrollModalTop();
  window.addEventListener('scroll', handleScrollModalTop);
  window.addEventListener('resize', handleScrollModalTop);
  // ----- END OF MODAL_PARENT & SEARCH_PARENT ----- //
  // ---- LIGHTGALLERY ---- //
  if (document.querySelectorAll('.album_list')) {
    var gallery = document.querySelectorAll(".album_list");
    gallery.forEach(function (pic) {
      lightGallery(pic, {
        speed: 500,
        plugins: [lgThumbnail],
        thumbnail: true
      });
    });
  }
  // ---- TABLE ---- //
  if (document.querySelector(".ck_editor")) {
    var tables = document.querySelectorAll(".ck_editor table");
    tables.forEach(function (table) {
      var parentTable = document.createElement('div');
      parentTable.classList.add("table_res");
      table.parentNode.replaceChild(parentTable, table);
      parentTable.appendChild(table);
    });
  }
  // *.*.*.*.*.*.*.*.*.*.* START OF company ajax search *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector("#company-search-input")) {
    function searchCompanies(searchTerm) {
      fetch(`/companies/ajaxSearch?q=${encodeURIComponent(searchTerm)}`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error(`Request failed for ajax company search. Returned status of ${response.status}`);
          }
        })
        .then((companies) => {
          var companyItems = "";
          var companyList = document.getElementById("company-list");

          if (companies.length === 0) {
            companyItems = `<div class="fade-in not_found">${NOT_FOUND_TEXT}</div>`;
          } else {
            companyItems = companies.reduce((acc, company) => {
              return (
                acc +
                `<li class="fade-in">
                <a href='${company.url}' target='_blank' class='image'>
                <img loading='lazy' width='50' height='50' alt='${company.title}' src='${company.image}' />
                </a>
                <a class='title' href='${company.url}' title='${company.title}' target='_blank'>${company.title}</a>
                </li>`
              );
            }, "");
          }
          companyList.innerHTML = companyItems;
        })
        .catch((error) => {
          console.error(error);
        });
    }

    document.getElementById("company-search-input").addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault(); // Prevent the default form submission
        var searchTerm = document.getElementById("company-search-input").value;
        searchCompanies(searchTerm);
      }
    });

    document.querySelector(".search_company").addEventListener("click", function () {
      var searchTerm = document.getElementById("company-search-input").value;
      searchCompanies(searchTerm);
    });
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF company ajax search *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START OF author ajax search *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector("#author-search-input")) {
    function searchAuthors(searchTerm) {
      fetch(`/authors/ajaxSearch?q=${encodeURIComponent(searchTerm)}`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error(`Request failed for ajax author search. Returned status of ${response.status}`);
          }
        })
        .then((authors) => {
          var authorItems = "";
          var authorList = document.getElementById("author-list");

          if (authors.length === 0) {
            authorItems = `<div class="fade-in not_found">${NOT_FOUND_TEXT}</div>`;
          } else {
            authorItems = authors.reduce((acc, author) => {
              return (
                acc +
                `<li class="fade-in">
                <a href='${author.url}' target='_blank' title='${author.title}' class='image'>
                <img loading='lazy' width='50' height='50'  alt='${author.title}' src='${author.image}' />
                </a>
                <a class='title' href='${author.url}' title='${author.title}' target='_blank'>${author.title}</a>
                </li>`
              );
            }, "");
          }
          authorList.innerHTML = authorItems;
        })
        .catch((error) => {
          console.error(error);
        });
    }

    document.getElementById("author-search-input").addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault(); // Prevent the default form submission
        var searchTerm = document.getElementById("author-search-input").value;
        searchAuthors(searchTerm);
      }
    });

    document.querySelector(".search_author").addEventListener("click", function () {
      var searchTerm = document.getElementById("author-search-input").value;
      searchAuthors(searchTerm);
    });
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF author ajax search *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  // ---- SHORT_LINK ---- //
  if (document.querySelector(".short_link")) {
    var shortLink = document.querySelector(".short_link");
    if (shortLink) {
      shortLink.addEventListener("click", function (event) {
        event.preventDefault();
        var temp = document.getElementById("short_link_copy");
        temp.select();
        document.execCommand("copy");
        document.querySelector(".copied").style.display = "flex";
        setTimeout(function () {
          document.querySelector(".copied").style.display = "none";
        }, 3000);
      });
    }
  }
  // ---- AUTHOR ---- //
  if (document.querySelector('.profile_content_display')) {
    if (document.querySelector(".profile_content_display").scrollHeight > 350) {
      document.querySelector(".profile_content_button").addEventListener('click', function () {
        document.querySelector(".profile_content_display").classList.toggle('profile_content_display_show');
        document.querySelector(".profile_content_display").style.maxHeight = document.querySelector(".profile_content_display").scrollHeight + "px";
        document.querySelector(".profile_content_button").style.display = "none";
      })
    } else {
      if (document.querySelector('.profile_content_display')) {
        document.querySelector(".profile_content_button").style.display = "none";
      }
    }
  }
  // ---- LIGHTGALLERY ---- //
  if (document.querySelectorAll('.album_list')) {
    var gallery = document.querySelectorAll(".album_list");
    gallery.forEach(function (pic) {
      lightGallery(pic, {
        speed: 500,
        plugins: [lgThumbnail],
        thumbnail: true
      });
    });
  }
  // ---- TABLE ---- //
  if (document.querySelector(".ck_editor")) {
    var tables = document.querySelectorAll(".ck_editor table");
    tables.forEach(function (table) {
      var parentTable = document.createElement('div');
      parentTable.classList.add("table_res");
      table.parentNode.replaceChild(parentTable, table);
      parentTable.appendChild(table);
    });
  }
})
